/**
 * How a booking list is split into tabs on a phone, for both the fleet portal and the
 * workshop.
 *
 * Small on purpose. It exists because the alternative is the string `'COMPLETED'` and
 * the words "Not completed" living in two files that must agree — and the moment they
 * disagree, one screen files a booking under a tab the other calls something else.
 */

/** The one status that counts as done. Everything else is "not completed". */
export const COMPLETED_STATUS = 'COMPLETED';

/** Group keys, in display order. */
export const BOOKING_STATUS_KEYS = ['open', 'completed'];

/**
 * Which tab a booking belongs in.
 *
 * The partition is deliberately total. COMPLETED is done; everything else — SCHEDULED,
 * JOB_STARTED, VEHICLE_RECEIVED, and also CANCELLED and NO_SHOW — is "not completed",
 * which is literally true. Every booking therefore appears in exactly one tab and none
 * can go missing, and each row still carries its own status pill so a cancelled booking
 * is not mistaken for a live one.
 */
export const groupBookingByStatus = (booking) =>
    (booking.status === COMPLETED_STATUS ? 'completed' : 'open');

/** Pill options with counts, so both screens label and count the tabs identically. */
export const bookingStatusOptions = (counts) => ([
    { key: 'open', label: 'Not completed', badge: counts.open },
    { key: 'completed', label: 'Completed', badge: counts.completed },
]);
